import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardActions, Typography, Button, CardHeader } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  card: {
    "&:hover": {
      transform: 'scale(1.02)',
      WebkitTransform: 'scale(1.02)',
      boxShadow: "inset 0 0 0 2px",
      cursor: 'pointer'
    }
  },
  tourheaderbox: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  }
}));

const MembershipCard = props => {
  const classes = useStyles();
  return (
    <div>
      <Card className={classes.card}>
        <CardHeader className={classes.tourheaderbox}
          title={props.membership.PackageName}
          titleTypographyProps={{ color: "inherit" }}
        />
        <CardContent>
          <Typography component="p" color="textSecondary">
            <br />
            {props.membership.PackageName}
          </Typography>
        </CardContent>
        <CardActions>

          <Button variant="contained" color="primary" onClick={() => props.JoinMemberships(props.membership)}>Join</Button>
          <Button variant="contained" color="primary" onClick={() => props.RenewMembership(props.membership)}> Renew</Button>

        </CardActions>
      </Card>
    </div>
  );
};

export default MembershipCard;
